import { render, staticRenderFns } from "./dosion-audio.vue?vue&type=template&id=2f8518e0&"
import script from "./dosion-audio.vue?vue&type=script&lang=js&"
export * from "./dosion-audio.vue?vue&type=script&lang=js&"
import style0 from "./dosion-audio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports